import { useSelector } from 'react-redux';
import Loader from './Loader';

const LoaderContainer = () => {
  const { isFetching, message } = useSelector(({ httpReducer }) => httpReducer);

  return <Loader isFetching={isFetching} message={message} />;
};

export default LoaderContainer;
